import { withStyles, makeStyles } from '@material-ui/core/styles'
import styles from 'src/assets/jss/material-dashboard-react/views/chartsStyle'
import TableCell from '@material-ui/core/TableCell'

export const useStyles = makeStyles(() => ({
  ...styles,
  table: {
    minWidth: 500,
  },
  center: {
    justifyContent: 'center',
    display: 'flex',
  },
  root: {
    width: '100%',
    '& > *': {
      color: '#fff',
    },
  },
}))

export const StyledTableCell = withStyles(theme => ({
  head: {
    backgroundColor: theme.palette.common.black,
    color: theme.palette.common.white,
  },
  body: {
    fontSize: 10,
  },
}))(TableCell)